import React from "react";
import PropTypes from "prop-types";
import "./index.scss";
import { fieldType } from "../../constants";
import ToolTip from "./Tooltip";
import { tooltipMsg } from "../../utils";
function Input(Props) {
  const {
    type,
    className,
    preIconClass,
    postIconClass,
    label,
    placeholder,
    handleChange,
    onIconClick,
    name,
    labelClass,
    labelIcon,
    optionLabel,
    value,
    onFocus,
    required,
    id,
    pattern,
    title,
    min,
    max,
    alt,
    readOnly = false
  } = Props;
  return (
    <div className="py-2 w-100">
      <label className={labelClass}>{label}
      {labelIcon && (
          <ToolTip placement="top" toolTipMessage={tooltipMsg()}>
            <img className="ps-2 cursor-pointer" alt="not found" src={labelIcon} />
          </ToolTip>
        )}
        {optionLabel && (
          <span className="option-badge">Optional</span>
        )}
        </label>
      <div className="custom_input">
        {preIconClass && (
          <span className="input_pre">
            {/* <i className={preIconClass}></i> */}
            <img src={preIconClass} alt={alt}/>
          </span>
        )}
        <input
          type={type === 'otp' ? 'tel' : type}
          name={name}
          className={className}
          value={value}
          id={id}
          placeholder={placeholder}
          onChange={handleChange}
          key={name}
          maxLength={fieldType[type] ?? null}
          onFocus={onFocus}
          required={required}
          pattern={pattern}
          title={title}
          min={min}
          max={max}
          disabled={readOnly}
        />
        {postIconClass && (
          <span className="input_post" onClick={onIconClick}>
            {/* <i className={postIconClass}></i> */}
            <img src={postIconClass} alt={alt}/>
          </span>
        )}
      </div>
    </div>
  );
}

Input.propTypes = {
  type: PropTypes.string,
  className: PropTypes.string,
  preIconClass: PropTypes.string,
  postIconClass: PropTypes.string,
  labelClass: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string,
  placeholder: PropTypes.string,
  handleChange: PropTypes.func,
  onIconClick: PropTypes.func,
  onFocus: PropTypes.func,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  required:PropTypes.bool,
  pattern: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  min:PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  max:PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  labelIcon:PropTypes.string,
  optionLabel:PropTypes.string
};

Input.defaultProps = {
  type: "text",
  className: "form-control grey-input with_icon",
  preIconClass: "",
  postIconClass: "",
  label: "label",
  placeholder: "",
  handleChange: () => null,
  onIconClick: () => null,
  name: "",
  labelClass: "hidden",
  value: "",
  onFocus: () => null,
  id: '',
  reqired:false,
  pattern:null,
  title: null,
  min:null,
  max:null,
  labelIcon: "",
  optionLabel: ""
};

export default Input;
